App.namespace('components.page_visibility_api', () => {
  // Set the name of the hidden property and the change event for visibility
  let hidden;
  let visibilityChange;
  if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  const isPageHidden = () => {
    return !!(document.hidden || document.msHidden || document.webkitHidden || document.mozHidden);
  };

  const isPageVisible = () => !isPageHidden();

  const init = (onVisibilityChange) => {
    // Do nothing if unsupported browser
    if (!hidden) {
      return;
    }

    if (!onVisibilityChange) {
      return;
    }

    // Handle page visibility change
    document.addEventListener(visibilityChange, () => {
      const isHidden = isPageHidden();
      onVisibilityChange({
        hidden: isHidden,
        visible: !isHidden,
      });
    }, false);
  };

  return {
    init,
    isPageHidden,
    isPageVisible,
  };
});
